.button {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 0.75rem 1.5rem;
	border: none;
	border-radius: 8px;
	font-size: 1rem;
	font-weight: 600;
	cursor: pointer;
	text-decoration: none;
	transition: all 0.2s ease;
	font-family: inherit;
	line-height: 1.5;

	&:disabled {
		opacity: 0.6;
		cursor: not-allowed;
	}

	&:active:not(:disabled) {
		transform: translateY(1px);
	}
}

.button-filled {
	background-color: #228be6;
	color: #ffffff;

	&:hover:not(:disabled) {
		background-color: #1971c2;
	}

	&:active:not(:disabled) {
		background-color: #1864ab;
	}
}

.button-subtle {
	background-color: transparent;
	color: #495057;
	padding: 0.625rem 1rem;

	&:hover:not(:disabled) {
		background-color: #f1f3f5;
		color: #212529;
	}

	&:active:not(:disabled) {
		background-color: #e9ecef;
	}
}

.button-outline {
	background-color: transparent;
	color: #228be6;
	border: 2px solid #228be6;

	&:hover:not(:disabled) {
		background-color: #e7f5ff;
	}

	&:active:not(:disabled) {
		background-color: #d0ebff;
	}
}

.button-light {
	background-color: #e7f5ff;
	color: #1971c2;

	&:hover:not(:disabled) {
		background-color: #d0ebff;
	}

	&:active:not(:disabled) {
		background-color: #a5d8ff;
	}
}

// Dark mode adjustments
@media (prefers-color-scheme: dark) {
	.button-filled {
		background-color: #1971c2;

		&:hover:not(:disabled) {
			background-color: #1864ab;
		}

		&:active:not(:disabled) {
			background-color: #145ca4;
		}
	}

	.button-subtle {
		color: #adb5bd;

		&:hover:not(:disabled) {
			background-color: #373a40;
			color: #f1f3f5;
		}

		&:active:not(:disabled) {
			background-color: #5c5f66;
		}
	}

	.button-outline {
		color: #4dabf7;
		border-color: #4dabf7;

		&:hover:not(:disabled) {
			background-color: #25262b;
		}

		&:active:not(:disabled) {
			background-color: #373a40;
		}
	}

	.button-light {
		background-color: #25262b;
		color: #74c0fc;

		&:hover:not(:disabled) {
			background-color: #373a40;
		}

		&:active:not(:disabled) {
			background-color: #5c5f66;
		}
	}
}
